import React from 'react';

import type { FeatureHeaderProperties } from './index';
import { CroppedImage } from '@weee-fe/module';
import { twMerge } from 'tailwind-merge';
interface IconProps {
  wrapperClassName?: string;
  className?: string;
  properties: FeatureHeaderProperties;
}

const Icon: React.FC<IconProps> = ({ className, wrapperClassName, properties }) => {
  const { icon, title } = properties;

  if (!icon) return <></>;
  return (
    <CroppedImage
      url={icon}
      configs={{
        renderHeight: 60
      }}
      loadingPlaceholderClassName="bg-[#ffffff]"
      wrapperClassName={twMerge(
        'w-[60px] h-[60px] p-2 border border-solid border-surface-100-hairline rounded-300 bg-[#ffffff] box-border',
        wrapperClassName
      )}
      className={twMerge('w-full h-full object-contain', className)}
      alt={`${title}-icon`}
      data-testid="wid-featured-header-icon"
    />
  );
};

export default Icon;
